/**
 * O aviso do topo de Notificações (docs/spec/settings.md): os avisos do sistema estão desligados e as
 * mensagens diretas pedem aviso. Com o pedido ainda em aberto, o botão pede a permissão; se o
 * navegador já bloqueou, só dá para liberar nas permissões do site.
 */
import { useEffect, useState } from 'react';
import { useT } from '../i18n/index.js';
import { askSystemNotices } from '../notify.js';
import { useApp } from '../store.js';
import { Button } from '../ui/controls.js';

/** O pedido da permissão saiu de outro lugar (a escolha do segmentado): o aviso relê o estado. */
export const NOTICES_EVENT = 'rpgdesk:notices-permission';

function permission(): NotificationPermission | null {
  return typeof Notification === 'undefined' ? null : Notification.permission;
}

export function NoticesBanner() {
  const t = useT();
  const wanted = useApp((s) => s.settings.messageNotice !== 'never');
  const [state, setState] = useState(permission);
  useEffect(() => {
    const read = () => setState(permission());
    window.addEventListener(NOTICES_EVENT, read);
    window.addEventListener('focus', read);
    return () => {
      window.removeEventListener(NOTICES_EVENT, read);
      window.removeEventListener('focus', read);
    };
  }, []);
  if (!wanted || state === null || state === 'granted') return null;
  return (
    <div className="rd-prefs__banner" role="status">
      <div className="rd-prefs__bannerText">
        <strong>{t('prefs.notify.banner.title')}</strong>
        <span>{state === 'denied' ? t('prefs.notify.banner.blocked') : t('prefs.notify.banner.text')}</span>
      </div>
      {state === 'default' ? (
        <Button
          variant="action"
          onClick={async () => {
            await askSystemNotices();
            setState(permission());
          }}
        >
          {t('prefs.notify.banner.allow')}
        </Button>
      ) : null}
    </div>
  );
}
